export default [

  {
    path: '/cosecha/mantenedor_c/grupo',
    name: 'grupore',
    component: () => import('@/views/cosecha/mantenedor/grupo.vue'),
    meta: {
      pageTitle: 'Listar Grupos',
      breadcrumb: [
        {
          text: 'Grupo nuevo',
        },
        {
          text: 'Listar Grupos',
          active: true,
        },
      ],
      resource: 'Grupo Re',
      action: 'menu',
    },
  },
  {
    path: '/cosecha/mantenedor_c/actividad',
    name: 'actividadre',
    component: () => import('@/views/cosecha/mantenedor/actividad.vue'),
    meta: {
      pageTitle: 'Listar Actividades',
      breadcrumb: [
        {
          text: 'Actividad nueva',
        },
        {
          text: 'Listar Actividades',
          active: true,
        },
      ],
      resource: 'Actividad Re',
      action: 'menu',
    },
  },
  {
    path: '/cosecha/mantenedor_c/labor',
    name: 'laborre',
    component: () => import('@/views/cosecha/mantenedor/labor.vue'),
    meta: {
      pageTitle: 'Listar Labores',
      breadcrumb: [
        {
          text: 'Labor nueva',
        },
        {
          text: 'Listar Labores',
          active: true,
        },
      ],
      resource: 'Labor Re',
      action: 'menu',
    },
  },
  {
    path: '/cosecha/mantenedor_c/categoria',
    name: 'categoriare',
    component: () => import('@/views/cosecha/mantenedor/categoria.vue'),
    meta: {
      pageTitle: 'Listar Categorías',
      breadcrumb: [
        {
          text: 'Categoría nueva',
        },
        {
          text: 'Listar Categorías',
          active: true,
        },
      ],
      resource: 'Categoria Re',
      action: 'menu',
    },
  },
  {
    path: '/cosecha/mantenedor_c/plantilla_categoria',
    name: 'plantillacategoriare',
    component: () => import('@/views/cosecha/mantenedor/plantilla_categoria.vue'),
    meta: {
      pageTitle: 'Listar Plantillas Categorías',
      breadcrumb: [
        {
          text: 'Plantilla Categoría nueva',
        },
        {
          text: 'Listar Plantillas Categorías',
          active: true,
        },
      ],
      resource: 'Plantilla Categoria Re',
      action: 'menu',
    },
  },
  {
    path: '/cosecha/mantenedor_c/criterio_categoria',
    name: 'criteriocategoriare',
    component: () => import('@/views/cosecha/mantenedor/criterio_categoria.vue'),
    meta: {
      pageTitle: 'Listar Criterio Categorías',
      breadcrumb: [
        {
          text: 'Criterio Categoría nuevo',
        },
        {
          text: 'Listar Criterios Categorías',
          active: true,
        },
      ],
      resource: 'Criterio Categoria Re',
      action: 'menu',
    },
  },
  {
    path: '/cosecha/mantenedor_c/parametro',
    name: 'cosparametrore',
    component: () => import('@/views/cosecha/mantenedor/parametro.vue'),
    meta: {
      pageTitle: 'Listar Parámetros',
      breadcrumb: [
        {
          text: 'Parámetros',
        },
        {
          text: 'Listar Parámetros',
          active: true,
        },
      ],
      resource: 'Cos Parametro Re',
      action: 'menu',
    },
  },
  {
    path: '/cosecha/mantenedor_c/dia_no_laborable',
    name: 'cosdiaferiadore',
    component: () => import('@/views/cosecha/mantenedor/dia_feriado.vue'),
    meta: {
      pageTitle: 'Listar Día no Laborable',
      breadcrumb: [
        {
          text: 'Día no laborable',
        },
        {
          text: 'Listar Día no Laborable',
          active: true,
        },
      ],
      resource: 'Cos diaFeriado Re',
      action: 'menu',
    },
  },
  {
    path: '/cosecha/baja_productividad/trabajador',
    name: 'trabajadornuevore',
    component: () => import('@/views/cosecha/baja_productividad/trabajador_nuevo.vue'),
    meta: {
      pageTitle: 'Listar Trabajadores',
      breadcrumb: [
        {
          text: 'Trabajador nuevo',
        },
        {
          text: 'Listar Trabajadores',
          active: true,
        },
      ],
      resource: 'Trabajador Nuevo Re',
      action: 'menu',
    },
  },
  {
    path: '/cosecha/baja_productividad/ratio_cosecha',
    name: 'ratiocosechare',
    component: () => import('@/views/cosecha/baja_productividad/ratio_cosecha.vue'),
    meta: {
      pageTitle: 'Listar Ratios Cosecha',
      breadcrumb: [
        {
          text: 'Ratios',
        },
        {
          text: 'Listar Ratios Cosecha',
          active: true,
        },
      ],
      resource: 'Ratio Cosecha Re',
      action: 'menu',
    },
  },
  {
    name: 'resumenratiore',
    path: '/cosecha/baja_productividad/resumen_ratio',
    component: () => import('@/views/cosecha/baja_productividad/resumen_ratio_cosecha.vue'),
    meta: {
      pageTitle: 'Listar Resumen Ratio',
      breadcrumb: [
        {
          text: 'Resumen Ratio',
        },
        {
          text: 'Listar Resumen Ratio',
          active: true,
        },
      ],
      resource: 'Resumen Ratio Re',
      action: 'menu',
    },
  },
  {
    name: 'trabajadorexcluido',
    path: '/cosecha/trabajador_excluido/excluido',
    component: () => import('@/views/cosecha/baja_productividad/trabajador_excluido.vue'),
    meta: {
      pageTitle: 'Listar trabajador excluido',
      breadcrumb: [
        {
          text: 'Trabajador excluido',
        },
        {
          text: 'Listar  Trabajador excluido',
          active: true,
        },
      ],
      resource: 'Dar Baja Trabajador Re',
      action: 'menu',
    },
  },
  {
    name: 'darbajatrabajadorre',
    path: '/cosecha/baja_productividad/baja_trabajador',
    component: () => import('@/views/cosecha/baja_productividad/baja_trabajador.vue'),
    meta: {
      pageTitle: 'Listar dar baja trabajador',
      breadcrumb: [
        {
          text: 'Dar baja trabajador',
        },
        {
          text: 'Listar  dar baja trabajador',
          active: true,
        },
      ],
      resource: 'Dar Baja Trabajador Re',
      action: 'menu',
    },
  },
  {
    name: 'rendimientosemanare',
    path: '/cosecha/baja_productividad/redimiento_semanal',
    component: () => import('@/views/cosecha/baja_productividad/rendimiento_semanal.vue'),
    meta: {
      pageTitle: 'KPI - Trabajadores Nuevos',
      breadcrumb: [
        {
          text: 'Indicador Redenimiento Semanal',
        },
        {
          text: 'Listar Indicador Rendimiento Semanal',
          active: true,
        },
      ],
      resource: 'Rendimiento Semanal Re',
      action: 'menu',
    },
  },


  {
    name: 'listanegrare',
    path: '/cosecha/baja_productividad/lista_observado',
    component: () => import('@/views/cosecha/baja_productividad/lista_negra.vue'),
    meta: {
      pageTitle: 'Listar Observados Área Cosecha',
      breadcrumb: [
        {
          text: 'Observados Área Cosecha',
        },
        {
          text: 'Listar Observados Área Cosecha',
          active: true,
        },
      ],
      resource: 'Lista Negra Re',
      action: 'menu',
    },
  },
  {
    name: 'vistanewre',
    path: '/cosecha/baja_productividad/observados_rr_hh',
    component: () => import('@/views/cosecha/baja_productividad/lista_negra_rr_hh.vue'),
    meta: {
      pageTitle: 'Listar Observados Área RR.HH',
      breadcrumb: [
        {
          text: 'Observados Área RR.HH',
        },
        {
          text: 'Listar Observados Área RR.HH',
          active: true,
        },
      ],
      resource: 'Vista New Re',
      action: 'menu',
    },
  },
  {
    name: 'cosechaobservadore',
    path: '/cosecha/baja_productividad/tablero_cruce',
    component: () => import('@/views/cosecha/baja_productividad/cosecha_observado.vue'),
    meta: {
      pageTitle: 'Listar Reingreso Obs/Lista Negra',
      breadcrumb: [
        {
          text: 'Reingreso Observados/Lista Negra',
        },
        {
          text: 'Listar Reingreso Obs/Lista Negra',
          active: true,
        },
      ],
      resource: 'Cosecha Observado Re',
      action: 'menu',
    },
  },
  /*
  {
    name: 'vistanewre',
    path: '/cosecha/baja_productividad/vista_nuevass',
    component: () => import('@/views/cosecha/baja_productividad/baja_trabajador_test.vue'),
    meta: {
      pageTitle: 'Listar Cosecha Observados',
      breadcrumb: [
        {
          text: 'Cosecha Observados',
        },
        {
          text: 'Listar cosecha observados',
          active: true,
        },
      ],
      resource: 'Vista New Re',
      action: 'menu',
    },
  },
  */
  /*
 {
   name: 'vistanewdosres',
   path: '/cosecha/baja_productividad/vista_nuevassdosss',
   component: () => import('@/views/cosecha/filtros_baja.vue'),
   meta: {
     pageTitle: 'Listar Observadosss',
     breadcrumb: [
       {
         text: 'Cosecha Observadosss',
       },
       {
         text: 'Listar cosecha observados',
         active: true,
       },
     ],
     resource: 'Vista New Dos Res',
     action: 'menu',
   },
 },
 */
  {
    path: '/cosecha/mantenedor_c/dia_canjeado',
    name: 'cosdiacanjeadore',
    component: () => import('@/views/cosecha/mantenedor/dia_canjeado.vue'),
    meta: {
      pageTitle: 'Listar Dia Canjeado',
      breadcrumb: [
        {
          text: 'Día canjeado',
        },
        {
          text: 'Listar Día Canjeado',
          active: true,
        },
      ],
      resource: 'Cos Dia Canjeado Re',
      action: 'menu',
    },
  },

  {
    path: "/cosecha/historial_cosechadores",
    name: "historial_cosechadores",
    component: () => import("@/views/cosecha/historial_cosechadores.vue"),
    meta: {
      pageTitle: "Historial de Cosechadores",
      breadcrumb: [
        {
          text: "Cosecha",
        },
        {
          text: "Historial Cosechadores",
          active: true,
        },
      ],
      resource: "Historial Cosechadores",
      action: "menu",
    },
  },
  {
    path: "/cosecha/historial/historial_dias_experiencia",
    name: "historialdiaexperiencia",
    component: () => import("@/views/cosecha/historial/historial_dias_experiencia.vue"),
    meta: {
      pageTitle: "Historial Días de Experiencia",
      breadcrumb: [
        {
          text: "Días de Experiencia",
        },
        {
          text: "Historial Días de Experiencia",
          active: true,
        },
      ],
      resource: "Historial Dia Experiencia",
      action: "menu",
    },
  },


]
